import request from "@/utils/request";

// 收藏 API
// 获取收藏列表
export function favoritesListApi(params: { page?: number; limit?: number }) {
  return request({
    url: "/front/wishlist/list",
    method: "GET",
    params,
  });
}

// 添加收藏
export function addFavoriteApi(data: { productId: number }) {
  return request({
    url: "/front/wishlist/save",
    method: "POST",
    data,
  });
}

// 批量取消收藏
export function batchRemoveFavoriteApi(data: { ids: number[] }) {
  return request({
    url: "/front/wishlist/delete",
    method: "POST",
    data
  });
}
